<template>
  <v-card flat class="px-5">
    <ValidationObserver ref="observer">
      <template v-for="field in fields" >

        <div :key="field.title" class="text-subtitle-1 text-button my-7">
          {{ field.title }}
        </div>
        <v-row dense>
          <v-col cols="4" v-for="detail in field.details" :key="detail.name">
            <ValidationProvider
              :name="detail.label"
              :rules="detail.rules"
              events="['blur']"
              v-slot="{ errors }"
            >
              <v-select
                v-if="detail.type ==='select'"
                :label="detail.label"
                v-model="details[detail.value]"
                outlined
                dense
                :items="detail.items"
                :error-messages="errors"
              />
              <v-text-field
                v-else-if="detail.type ==='date'"
                :label="detail.label"
                type="date"
                v-model="details[detail.value]"
                outlined
                dense
                :error-messages="errors"
              />
              <vuetify-money
                v-else-if="detail.type ==='money'"
                type="number"
                outlined
                dense
                required
                :label="detail.label"
                v-model.number="details[detail.value]"
                :error-messages="errors"
                :options="VuetifyMoneyOptions"
              />
              <v-text-field
                v-else
                :label="detail.label+ detail.rules.includes('required') ? '*': ''"
                v-model="details[detail.value]"
                outlined
                dense
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>

        </v-row>
      </template>
    </ValidationObserver>
  </v-card>
</template>

<script>
import { VuetifyMoneyOptions } from '@/lib/constants/options';

export default {
  data() {
    return {
      VuetifyMoneyOptions,
      details: {},
      fields: [ 
        {
          title: '',
          details: [ 
            {
              label: "Account Number",
              value: "mainAccountNumber",
              rules: "required"
            },
            {
              type: 'select',
              items: ['Personal', 'General'],
              label: "Account Type",
              value: "accountType",
              rules: ""
            },
            {
              type: 'select',
              items: ['Active', 'InActive'],
              label: "Account Status",
              value: "accountStatus",
              rules: ""
            },
            {
              type: 'select',
              items: ['Face-to-Face'],
              label: "Account Opening Method",
              value: "accountOpeningMethod",
              rules: ""
            },
            {
              type: 'date',
              label: "Account Open Date",
              value: "accountOpeningDate",
              rules: "date"
            },
            {
              type: 'date',
              label: "Last Transaction Date",
              value: "lastTransactionDate",
              rules: "date"
            }
          ]
        },

        {
          title: 'Sub Account Details',
          details: [  
            {
              label: "Sub Account Name",
              value: "subAccountName",
              rules: ""
            },
            {
              type: 'money',
              label: "Available Balance",
              value: "availableBalance",
              rules: ""
            },
            {
              type: 'money',
              label: "Minimum Balance",
              value: "minimumBalance",
              rules: ""
            },
          ]
        }
      ]
    }
  },

  methods: {
    clear() {
      console.log('cleared...');
      this.details = {}
    },

    async validate() {
      return this.$refs.observer.validate();
    },

    submit() {
      this.$emit('submit', this.details)
    }
  }
}

</script>